if (!customElements.get('form-validate')) {
  class FormValidation extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) throw new Error('Form element does not exist');
    }

    toggleErrorMessage(input, field) {
      const errorMessageWrapper =
        field.querySelector('[data-message]');
      errorMessageWrapper.classList.toggle(
        'hidden',
        input.validity.valid
      );
      errorMessageWrapper.parentElement.classList.toggle(
        'has-error',
        !input.validity.valid
      );

      errorMessageWrapper.innerHTML =
        input.type === 'email'
          ? window.validationStrings.invalidEmail
          : input.validationMessage;
    }
    /* custom code start */
    setFieldValidity(input) {
      input.setAttribute('aria-invalid', !input.validity.valid);
      const field = input.closest('[data-input-wrapper]');
      if (!field) return;
      field.classList.toggle('has-error', !input.validity.valid);
      this.toggleErrorMessage(input, field);
    }

    onSubmit(event) {
      if (!this.form.reportValidity()) {
        event.preventDefault();
        return;
      }
    }

    setHandlers() {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      for (const input of this.form.elements) {
        if (input.hasAttribute('data-no-validate')) continue;

        ['input', 'blur', 'change', 'invalid'].forEach(eventName => {
          input.addEventListener(
            eventName,
            this.setInputHandler.bind(this)
          );
        });
      }
    }

    setInputHandler(event) {
      if (event._autofill) return;
      if (event.type === 'invalid') {
        event.preventDefault();
      }

      this.setFieldValidity(event.target);
    }

    detectAutofill() {
      const inputs = this.form.querySelectorAll('input');

      const dispatchAutofillEvent = (input) => {
        const event = new Event('change', { bubbles: true });
        event._autofill = true;
        input.dispatchEvent(event);
      };

      const checkAutofill = () => {
        inputs.forEach((input) => {
          try {
            if (input.matches(':-webkit-autofill')) {
              dispatchAutofillEvent(input);
            }
          } catch (_) {}
        });
      };

      setTimeout(checkAutofill, 300);
      setTimeout(checkAutofill, 1000);
      setTimeout(checkAutofill, 3000);
    }

    connectedCallback() {
      this.setHandlers();
      this.detectAutofill();
    }
  }
  /* custom code end */
  customElements.define('form-validate', FormValidation);
}
